import styled from 'styled-components';

import { Button, Typography } from '@libs/components';

export const BalanceContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  position: relative;

  ${({ theme }) => theme.media.laptop`
      flex: 1;
      max-width: 43rem;
  `}
`;

export const UsdtImg = styled.img`
  height: 4.1rem;
  width: 5.4rem;
  transform: scaleX(-1);
`;

export const BalanceFlexWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
`;

export const ClaimButton = styled(Button)`
  height: 6rem;
  position: relative;

  ${({ theme }) => theme.media.laptop`
       width: auto;
       max-width:43rem;
  `}
`;

export const SummaryContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;

  ${({ theme }) => theme.media.mobileL`
      grid-column-gap: 1.6rem;
      grid-row-gap: 1.6rem;
  `}
`;

export const SummaryMainContainer = styled.div`
  display: none;

  flex-direction: column;
  gap: 1.6rem;

  width: calc(100% - 4.4rem);

  padding: 1rem;
  margin: -8rem auto 0;

  z-index: ${({ theme }) => theme.zIndex.medium};

  background-color: ${({ theme }) => theme.colors.surface.default};

  border-radius: ${({ theme }) => theme.borderRadius.high};

  box-shadow: ${({ theme }) => theme.shadows.lg};

  ${({ theme }) => theme.media.mobileL`
     padding: 2rem;
  `}

  ${({ theme }) => theme.media.laptop`
      display: flex;
      margin: unset;
      position: unset;
      width: 37rem;
  `}
`;

export const SummaryField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.2rem;
  padding: 1rem 0.8rem;
  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};

  ${({ theme }) => theme.media.mobileL`
       padding: 1.6rem 1.2rem;
  `}
`;

export const TooltipWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

export const CustomTypography = styled(Typography)`
  margin-right: 0.8rem;
`;

export const ResultFeedbackWrapper = styled.div`
  ${({ theme }) => theme.media.tabletL`
      display: flex;
      justify-content: center;
      width: 50rem
  `}
`;
